<style>
  #app {
    height: 100%;
    overflow: auto;
  }
</style>

<template>
  <div id="app">
    <md-snackbar md-position="top center" ref="snackbar" md-duration="4000">
      <span>{{ snackbarMessage }}</span>
      <md-button class="md-accent" @click.native="$refs.snackbar.close()">Lukk</md-button>
    </md-snackbar>

    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: 'app',

    data() {
      return {
        snackbarMessage: '',
      };
    },

    methods: {
      snackbar(message) {
        this.snackbarMessage = message;
        this.$refs.snackbar.open();
      },
    },
  };
</script>



// WEBPACK FOOTER //
// App.vue?3de5d3c9